import { Comment } from "../model/ticketEasy/Comment";

export class CommentPostCommand {
    ticketId: string;
    user: string;
    comment: string;

    constructor(comment: Comment) {
        this.ticketId = comment.ticketId;
        this.user = comment.user;
        this.comment = comment.comment;
    }
}